import { Route } from 'react-router';
import { getDepositAccountsPath } from '../path/path';
import { DepositAccountsPage } from '../DepositAccountsPage';
import { CreateDepositAccountPage } from '@/bundle/_OrgAdmin/pages/DepositAccountsPage/_CreateDepositAccountPage/CreateDepositAccountPage';
import { getCreateDepositAccountPath } from '@/bundle/_OrgAdmin/pages/DepositAccountsPage/_CreateDepositAccountPage/path/path';
import { DepositAccountDetailsPage } from '@/bundle/_OrgAdmin/pages/DepositAccountsPage/_DepositAccountDetailsPage/DepositAccountDetailsPage';
import { getDepositAccountDetailsPath } from '@/bundle/_OrgAdmin/pages/DepositAccountsPage/_DepositAccountDetailsPage/path/path';

export const DepositAccountsRoutes = [
  <Route key={getDepositAccountsPath()} path={getDepositAccountsPath()} element={<DepositAccountsPage />} />,
  <Route
    key={getDepositAccountDetailsPath()}
    path={getDepositAccountDetailsPath()}
    element={<DepositAccountDetailsPage />}
  />,
  <Route
    key={getCreateDepositAccountPath()}
    path={getCreateDepositAccountPath()}
    element={<CreateDepositAccountPage />}
  />,
];
